import { FC } from 'react';
import { navigate, PageProps } from 'gatsby';
import { useQueryClient } from 'react-query';
import { useUpdateCurrentOrderLineItemMutation } from 'lib/home/generated/queries';
import { MedusaLineItem, MedusaProductVariant } from 'lib/home/generated/types/api';
import { DefaultLayout, MealSwapWithFilters } from '../components';
import { swapMealInCurrentOrder } from '../util/helpers/swap';

interface MealSwapState {
  item: MedusaLineItem;
}
interface MealSwapPageProps {
  item: MedusaLineItem;
}

const MealSwapPage: FC<MealSwapPageProps> = ({ item }) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isSuccess } = useUpdateCurrentOrderLineItemMutation({
    onSuccess: async data => {
      const {
        updateCurrentOrderLineItem: { medusa_cart }
      } = data;

      swapMealInCurrentOrder(queryClient, medusa_cart);
      navigate('/');
    }
  });

  const handleSwap: (cartItemId: string, variant: MedusaProductVariant, handleSuccess?: () => void) => void = (
    id,
    { id: variant_id },
    handleSuccess
  ) => {
    mutate({ input: { id, variant_id } }, { onSuccess: data => handleSuccess && handleSuccess() });
  };

  return (
    <DefaultLayout backTo="/">
      <MealSwapWithFilters
        isLoading={isLoading}
        isSuccess={isSuccess}
        item={item}
        onSwap={handleSwap}
        onBackClick={() => navigate('/')}
      />
    </DefaultLayout>
  );
};

const MealSwapPageWrapper: FC<PageProps<object, object, MealSwapState>> = ({ location }) => {
  const item = location.state?.item;

  if (!item && typeof window !== `undefined`) {
    navigate('/');
    return null;
  }

  return <MealSwapPage item={item} />;
};

export default MealSwapPageWrapper;
